function Intro({ start, end }: { start: string; end: string }) {
  return (
    <aside className="intro">
      <h1>What the hex?</h1>
      <p>
        This map shows what homes have sold for across the city from {start} to {end},
        and how fast those prices are changing. Click a hexagon for the numbers. The
        buttons on the map switch between the average sale price and the yearly change,
        and between the price of the home and the price per square foot.
      </p>
      <p>
        A hex is colored for price change only when enough sales, across enough
        seasons, show a direction. Everywhere else stays an outline.
      </p>
      <p className="intro-credit">
        Made with Jack, who maps housing and community at{' '}
        <a href="https://ginkgoes.org/" target="_blank" rel="noopener noreferrer">ginkgoes.org</a>.
      </p>
    </aside>
  );
}

export default Intro;
